const values = [
  {
    icon: "ri-moon-line",
    title: "Quiet Over Noise",
    desc: "We curate spaces that feel calm, unhurried, and free from visual clutter — because rest starts with what you see.",
  },
  {
    icon: "ri-leaf-line",
    title: "Natural Over Synthetic",
    desc: "Linen, wood, ceramic, stone. Materials that age beautifully and bring the outside world gently in.",
  },
  {
    icon: "ri-heart-line",
    title: "Warmth Over Perfection",
    desc: "A home should feel lived-in and loved. We celebrate softness, texture, and the comfort of imperfection.",
  },
  {
    icon: "ri-eye-line",
    title: "Visual First",
    desc: "Every space we share is chosen for how it makes you feel — not just how it looks.",
  },
  {
    icon: "ri-subtract-line",
    title: "Less, But Better",
    desc: "We believe in fewer, more beautiful things. Chosen carefully. Arranged with intention.",
  },
  {
    icon: "ri-home-heart-line",
    title: "Everyday Calm",
    desc: "This is not about aspirational living. It is about making your actual home feel like a place of peace.",
  },
];

export default function AboutValues() {
  return (
    <section className="py-28 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        {/* Header */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-end mb-16">
          <div>
            <p
              className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              What We Believe
            </p>
            <h2
              className="text-[#2C2825] text-3xl md:text-4xl lg:text-5xl"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Our <em>Values</em>
            </h2>
          </div>
          <p
            className="text-[#8B8378] text-sm md:text-base leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            The quiet principles behind every space we choose to share.
          </p>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((val) => (
            <div
              key={val.title}
              className="bg-[#FAF7F0] rounded-2xl p-8 flex flex-col gap-4"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#EDE6DA] rounded-full flex-shrink-0">
                <i className={`${val.icon} text-[#8B8378] text-lg`} />
              </div>
              <h3
                className="text-[#2C2825] text-lg"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 500 }}
              >
                {val.title}
              </h3>
              <p
                className="text-[#8B8378] text-sm leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
              >
                {val.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
